import React from 'react';
import auth, { Auth } from './modules/auth';
import supplier, { Supplier } from './modules/supplier';
import ota, { Ota } from './modules/ota';

export type RootStore = {
  auth: Auth;
  supplier: Supplier;
  ota: Ota;
};

export const store: RootStore = {
  auth,
  supplier,
  ota
};

const StoreContext = React.createContext<RootStore>(store);

export const StoreProvider = StoreContext.Provider;

export const useStore = () => React.useContext(StoreContext);

export { auth, supplier, ota };
